import { render } from "./HomeContainer.vue?vue&type=template&id=15115f42"
import script from "./HomeContainer.vue?vue&type=script&lang=js"
export * from "./HomeContainer.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/tradeapponeonline/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__